const config = {
  audio: false,
  video: {
    facingMode: "user",
    width: 640,
    height: 480,
    frameRate: { max: 30 },
  },
};

export default config;
